export const InitialLinkedinData = {
  payload: {
    latitute: "",
    longitude: "",
  },
};
